import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import ReadOnlyPanel from "editor/components/ReadOnlyPanel";
import { setReadOnly } from "editor/actions/status";
import { API_TO_URL } from "config/constants/editor";

class ContentOutOfDateContainer extends React.Component {
  constructor() {
    super();
    this.reload = this._reload.bind(this);
  }

  _reload() {
    window.location.reload();
  }

  componentDidUpdate(prevProps) {
    if (this.props.contentOutOfDate && !prevProps.contentOutOfDate) {
      this.props.setReadOnly(true);
    }
  }

  render() {
    return (
      <>
        {this.props.children}
        <ReadOnlyPanel
          isVisible={this.props.contentOutOfDate}
          description={`This is an out-of-date version of this ${
            API_TO_URL[this.props.contentType]
          }. Refresh to see the newest version.`}
          button="Refresh"
          onClick={this.reload}
          key="out-of-date"
        />
      </>
    );
  }
}

const mapStateToProps = state => ({
  contentOutOfDate: state.editor.status.contentOutOfDate,
  contentType: state.editor.status.editorType.name,
});

const mapDispatchToProps = {
  setReadOnly,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ContentOutOfDateContainer);

ContentOutOfDateContainer.propTypes = {
  contentOutOfDate: PropTypes.bool.isRequired,
  contentType: PropTypes.string.isRequired,
  setReadOnly: PropTypes.func.isRequired,
};
